import React from "react";
import ReactDOM from "react-dom";
import "../../../style.css";
function Container() {
    return React.createElement("main", null, "P\u0142atno\u015B\u0107 nieudana!");
}
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(React.createElement(Container, null), document.body.querySelector("#container"));
